import { Injectable } from '@angular/core';
import { AppService } from '../../core/service/Base.Service';
import { DataTransferObject } from '../../core/entities/DataTransferObject';

@Injectable()
export class ImageService extends AppService<any> {

    constructor() {
        super('Image');
    }

    async uploadImage(data) {
        const dto: DataTransferObject<any> = <DataTransferObject<any>>{};
        dto.Data = {
            image: data
        };
        const result = await this.post('image', dto);
        return result;
    }

    async getImage(id) {
        if (id) {
            const result = await this.get('image', [id, 'Actual']);
            return result;
        }
    }

    async getImageAsFile(id) {
        if (id) {
            const result = await this.get('', id);
            return result;
        }
    }
}




// WEBPACK FOOTER //
// ./src/app/shell/shared/image.service.ts